import { motion, useSpring, useTransform } from "framer-motion";
import numeral from "numeral";
import React, { useEffect, useRef } from "react";

const RankingNumberCount = ({ value, notFixed = false }) => {
  const spring = useSpring(0, {
    mass: 0.8,
    stiffness: 75,
    damping: 15,
    restDelta: 0.01,
  });

  const display = useTransform(spring, (current) =>
    numeral(current).format(notFixed ? "0,0" : "0,0.0")
  );

  const intervalRef = useRef(null);

  useEffect(() => {
    let currentValue = value / 2;

    intervalRef.current = setInterval(() => {
      const increment = Math.floor(Math.random() * 400) + 100;
      currentValue += increment;

      if (currentValue >= value) {
        currentValue = value;
        clearInterval(intervalRef.current);
      }

      spring.set(currentValue);
    }, 5000);

    return () => clearInterval(intervalRef.current);
  }, [value, spring]);

  return <motion.span>{display}</motion.span>;
};

export default RankingNumberCount;
